import { EAuthProvider, IUserAuthProviderDto } from "interfaces";

export const getUserProvider = (
  authProviders: IUserAuthProviderDto[] | null | undefined,
  provider: EAuthProvider
): IUserAuthProviderDto | undefined => {
  return authProviders?.find((item) => item.provider === provider);
};

export const getUserProviderId = (
  authProviders: IUserAuthProviderDto[] | null | undefined,
  provider: EAuthProvider
): string | null => {
  return getUserProvider(authProviders, provider)?.providerUserId ?? null;
};

export const getUserProviderDisplayName = (
  authProviders: IUserAuthProviderDto[] | null | undefined,
  provider: EAuthProvider
): string | null => {
  return getUserProvider(authProviders, provider)?.providerDisplayName ?? null;
};

export const hasUserProvider = (
  authProviders: IUserAuthProviderDto[] | null | undefined,
  provider: EAuthProvider
): boolean => {
  return Boolean(getUserProvider(authProviders, provider));
};

export const isUserProviderVerified = (
  authProviders: IUserAuthProviderDto[] | null | undefined,
  provider: EAuthProvider
): boolean => {
  return getUserProvider(authProviders, provider)?.isVerified ?? false;
};

export const getDiscordProvider = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProvider(authProviders, EAuthProvider.DISCORD);

export const getDiscordId = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderId(authProviders, EAuthProvider.DISCORD);

export const getDiscordUsername = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderDisplayName(authProviders, EAuthProvider.DISCORD);

export const getTwitchProvider = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProvider(authProviders, EAuthProvider.TWITCH);

export const getTwitchId = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderId(authProviders, EAuthProvider.TWITCH);

export const getTwitchDisplayName = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderDisplayName(authProviders, EAuthProvider.TWITCH);

export const getSteamProvider = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProvider(authProviders, EAuthProvider.STEAM);

export const getSteamId = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderId(authProviders, EAuthProvider.STEAM);

export const getSteamDisplayName = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderDisplayName(authProviders, EAuthProvider.STEAM);

export const getGoogleProvider = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProvider(authProviders, EAuthProvider.GOOGLE);

export const getGoogleUsername = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderDisplayName(authProviders, EAuthProvider.GOOGLE);

export const getKickProvider = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProvider(authProviders, EAuthProvider.KICK);

export const getKickId = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderId(authProviders, EAuthProvider.KICK);

export const getKickDisplayName = (authProviders: IUserAuthProviderDto[] | null | undefined) =>
  getUserProviderDisplayName(authProviders, EAuthProvider.KICK);
